import { useEffect, useState } from "react";
import RoutingPaths from "../../utils/RoutingPaths";
import { NavLink } from "react-router-dom";

import orgLogo from "../../assets/images/org_logo.png";
import profile from "../../assets/images/profile.png";
import { ROLE_ASSISTANT, ROLE_FRONT_DESK_ADMIN } from "../../utils/Constants";

export default function Sidebar(props) {
  const client = JSON.parse(sessionStorage.getItem("ClientDetails"));
  const isClientUser = client !== null;

  const consultant = JSON.parse(sessionStorage.getItem("ConsultantDetails"));
  const userRole = JSON.parse(sessionStorage.getItem("UserRole"));
  const orgDetails = JSON.parse(sessionStorage.getItem("OrgDetails"));
  const isReportAccessAllowed =
    userRole === ROLE_ASSISTANT || userRole === ROLE_FRONT_DESK_ADMIN
      ? orgDetails && orgDetails?.isReportAccessAllowed
        ? orgDetails?.isReportAccessAllowed
        : false
      : true;
  const isConsultantUser = consultant !== null;
  const isPaymentInfoAccessAllowed = JSON.parse(
    sessionStorage.getItem("isPaymentInfoAccessAllowed")
  );

  const organizationDto = JSON.parse(sessionStorage.getItem("OrgDetails2"));

  const tabs = [
    {
      name: "Dashboard",
      path: RoutingPaths.DASHBOARD,
      icon: "bi bi-speedometer2",
      isOrganization: !isClientUser,
    },
    {
      name: "Appointments",
      path: RoutingPaths.APPOINTMENTS,
      icon: "bi bi-calendar-check",
      isOrganization: !isClientUser,
    },
    {
      name: "Hospitalizations",
      path: RoutingPaths.HOSPITALIZATION,
      icon: "bi bi-hospital",
      isOrganization:
        !isClientUser &&
        (isConsultantUser
          ? consultant?.useHospitalization
          : organizationDto?.isUseHospitalization),
    },
    {
      name: "Consultants",
      path: RoutingPaths.CONSULTANTS,
      icon: "bi bi-person",
      isOrganization: !isClientUser && !isConsultantUser,
    },
    {
      name: "Consultant Details",
      path: isConsultantUser
        ? RoutingPaths.CONSULTANT_DETAIL
        : `${RoutingPaths.CONSULTANT_DETAILS}/${consultant?.id}`,
      icon: "bi bi-person",
      isOrganization: isConsultantUser,
    },
    {
      name: "Contacts",
      path: RoutingPaths.CONTACTS,
      icon: "bi bi-journals",
      isOrganization: !isClientUser,
    },
    {
      name: "Schedule",
      path: RoutingPaths.SCHEDULE,
      icon: "bi bi-clipboard-check",
      isOrganization: !isClientUser,
    },
    {
      name: "Payments",
      path: RoutingPaths.PAYMENTS,
      icon: "bi bi-credit-card",
      isOrganization:
        !isClientUser &&
        (isPaymentInfoAccessAllowed === true ||
          isPaymentInfoAccessAllowed === null),
    },
    {
      name: "Contact Details",
      path: RoutingPaths.CONTACT_DETAIL,
      icon: "bi bi-person",
      isOrganization: isClientUser,
    },
    {
      name: "Reports",
      path: RoutingPaths.REPORTS,
      icon: "bi bi-file-earmark-pdf",
      isOrganization:
        !isClientUser && isReportAccessAllowed &&
        (isPaymentInfoAccessAllowed === true ||
          isPaymentInfoAccessAllowed === null),
    },
    {
      name: "Inventory",
      path: RoutingPaths.INVENTORIES,
      icon: "bi bi-file-medical",
      isOrganization:
        !isClientUser &&
        !isConsultantUser &&
        props?.profileData?.isMedicalInventory,
    },
  ];

  const orgImg = sessionStorage.getItem("OrgLogo");
  const consultantImg = sessionStorage.getItem("ConsultantLogo");
  const [img, setImg] = useState(orgImg);

  useEffect(() => {
    if (isClientUser) {
      setImg(profile);
    } else if (isConsultantUser) {
      setImg(consultantImg === "null" ? profile : consultantImg);
    } else {
      setImg(orgImg === "null" ? orgLogo : orgImg);
    }
  }, [orgImg, isClientUser, isConsultantUser, consultantImg]);

  return (
    <section
      className={`sidebarX  ${props.className ?? ""} ${
        props.isSidebarOpen ? "open" : ""
      }`}
    >
      {/* <div className="sidebar-toggle" onClick={props.toggleSidebar}>
        {props.isSidebarOpen ? (
          <i className="bi bi-caret-left" />
        ) : (
          <i className="bi bi-caret-right" />
        )}
      </div> */}

      <div className="sidebar-content">
        <div className="tab-org-profileX tab-tileX">
          <div className="tab-iconX">
            <img className="logo" src={img} alt="" />
          </div>
          {!isClientUser ? (
            <div className="tab-nameX text-capitalize sideBarName">
              <label className="textWrapper">
                {isConsultantUser
                  ? `${consultant?.firstName} ${consultant?.lastName}`
                  : props.profileData?.name}
              </label>
            </div>
          ) : (
            <div className="tab-nameX text-capitalize sideBarName">
              <label className="textWrapper">{`${client?.firstName} ${client?.lastName}`}</label>
            </div>
          )}
        </div>

        <nav className="tabX">
          {tabs.map(
            (tab) =>
              (tab.isOrganization || tab.isOrganization === undefined) && (
                <NavLink
                  className="tab-tileX"
                  to={tab.path}
                  end
                  key={tab.name}
                  title={tab.name}
                  onClick={props?.isSidebarOpen ? props?.toggleSidebar : null}
                >
                  <div className="tab-iconX">
                    <i className={tab.icon} />
                  </div>
                  <div className="tab-nameX">{tab.name}</div>
                  {tab.postInfo && <div className="tab-post-iconX">{`>`}</div>}
                </NavLink>
              )
          )}
        </nav>
      </div>
    </section>
  );
}